import styled from '@emotion/styled';

import SubformHeader from 'components/global/SubformHeader';

import { Breakpoints } from 'utils/const.styles';

export const RowSpaced = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin-top: var(--margin-2);
	margin-bottom: var(--margin-2);
	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);

	cursor: default;
	body[dir='rtl'] & {
		margin-right: unset;
		margin-left: var(--margin-1);
	}
	&:hover {
		background-color: var(--actionButtonColor);
	}
	@media ${Breakpoints.mobile} {
		flex-shrink: 1;
	}
`;

export const RowCentered = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;

	&:hover {
		background-color: var(--actionButtonColor);
	}
`;

export const RowCenteredActions = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: var(--padding-1);

	&:hover {
		background-color: var(--actionButtonColor);
	}

	@media ${Breakpoints.mobile} {
		padding: 0;
		> button {
			margin: 0;
		}
	}
`;
export const PartnersContainer = styled.div`
	transition: all 0.3s;
	background: var(--white);
	height: auto;
	overflow-x: auto;
	.emptySubtitle {
		margin: 2.5rem auto !important;
	}
`;

export const InputContainer = styled.div`
	width: 100%;
	position: relative;
	body[dir='rtl'] & {
		text-align: right;
	}
`;

export const LoadingRowSpaced = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	margin-top: var(--margin-2);
	margin-bottom: var(--margin-2);

	border: 1px solid var(--border-color);
	border-radius: var(--small-border-radius);
	cursor: default;
	body[dir='rtl'] & {
		margin-right: unset;
		margin-left: var(--margin-1);
	}
	@media ${Breakpoints.mobile} {
		display: flex;
	}
`;

export const LoadingRowCenteredActions = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	padding: var(--padding-1);
	> div {
		margin-right: 1rem;
		margin-left: 1rem;
	}

	@media ${Breakpoints.mobile} {
		margin-left: 1rem;
		width: fit-content;
		display: block;
		text-align: center;
		body[dir='rtl'] & {
			margin-left: unset;
			margin-right: 1rem;
		}
		> div {
			margin-bottom: 1rem;
			margin-right: 0.5rem;
			body[dir='rtl'] & {
				margin-right: 3rem;
			}
		}
	}
`;

export const LoadingRowCentered = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;

	> div {
		margin-right: 1rem;
		body[dir='rtl'] & {
			margin-left: 1rem;
			margin-right: unset;
		}
	}
	.loadingHeaderPadding {
		margin-bottom: 0.5rem;
	}

	@media ${Breakpoints.mobile} {
		justify-content: unset;
	}
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	flex: 1 1 auto;
	width: 100%;
	gap: 2rem;

	> div {
		display: flex;
		flex-direction: column;
		gap: 1rem;
		overflow: auto;
	}
`;

export const RowSpaceSla = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: right;
	gap: 1rem;
	align-items: center;
	margin-bottom: var(--margin-2);
	width: 100%;

	@media ${Breakpoints.mobile} {
		flex-shrink: 1;
	}
`;

export const RowCenteredSla = styled.div`
	display: flex;
	gap: 1rem;
	margin-right: 1rem;
	body[dir='rtl'] & {
		margin-left: 1rem;
		margin-right: unset;
	}
`;

export const SlotFormContainer = styled.div`
	padding: var(--padding-2);
	@media ${Breakpoints.mobile} {
		padding: var(--padding-3) var(--padding-5);
	}
`;

export const CheckboxContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
`;

export const SubFormHeaderContainer = styled(SubformHeader)`
	justify-content: space-evenly;
`;
